import Vue from "vue";
import Vuex from "vuex";
import sumBy from "lodash/sumBy";
import createPersistedState from "vuex-persistedstate";
// Kommentare entfernen, wenn nicht im sessionStorage sondern im LocalStorage encrypted werden soll...
// node_modules\secure-ls\dist\secure-ls.js  -> Line 130: 	    this.ls = sessionStorage; //statt   this.ls = localStorage;

import SecureLS from "secure-ls";
const ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "9NhDUygW&WrZQQR3VZCUQKMVXynoma",
  isCompression: true,
});

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    mieter_oid: "",
    token: "",
    loginEmail: "",
    loginName: "",
    loginSalutation: "",
    vertragsObjekte: [],
    fetchedVertragsobjekte: false,
    selectedObjekt: {},
    selectedDokumente: [],
    mieter: {
      vorname: "",
      nachname: "",
      langname: "",
      telefonnummer: "",
      mobilnummer: "",
      zustelladresse: {
        strasse: "",
        hausnr: "",
        top: "",
        plz: "",
        ort: "",
        land: "",
      },
      iban: "",
      bic: "",
      kontoname: "",
    },
    schadensfall: {
      zeitpunkt: "",
      titel: "",
      kategorien: [],
      bereich: [],
      beschreibung: "",
      status: "OPEN",
      bilderdatenset: [],
      // Im Bilderdatenset Array kommt pro File folgender JSON:
      // [
      //     {
      //         file: {
      //             name: 'file name',
      //             size: 'file size',
      //             base64: 'base64',
      //             format: 'file upload format. Bsp:image/jpeg;base64'
      //             tags: [],
      //             description: 'file description'
      //         }
      //     }
      //  ]
    },
    routerStatus: {
      ok: true,
      text: "",
    },
  },
  getters: {
    countNewElemente: (state) => {
      return (
        sumBy(state.vertragsObjekte, "countNewTermine") +
        sumBy(state.vertragsObjekte, "countNewBenachrichtigungen")
      );
    },
  },
  mutations: {
    reduceNewBenachrichtigung: (state) => {
      state.vertragsObjekte.forEach((objekt) => {
        if (objekt.countNewBenachrichtigungen > 0) {
          objekt.countNewBenachrichtigungen -= 1;
        }
      });
    },
    reduceNewTermin: (state, tovp_nr) => {
      state.vertragsObjekte.forEach((objekt) => {
        if (objekt.tovp_nr == tovp_nr) {
          if (objekt.countNewTermine > 0) {
            objekt.countNewTermine -= 1;
          }
        }
      });
    },
    setSepaData: (state, vertrag_oid) => {
      for (var vertragsObjekt of state.vertragsObjekte) {
        if (vertragsObjekt.vertrag_oid == vertrag_oid) {
          vertragsObjekt.sepa_iban = state.selectedObjekt.sepa_iban;
          vertragsObjekt.sepa_bic = state.selectedObjekt.sepa_bic;
          vertragsObjekt.sepa_inhaber = state.selectedObjekt.sepa_inhaber;

        }
      }
    },
    setMieterOid: (state, oid) => {
      Vue.set(state, "mieter_oid", oid);
    },
    setToken: (state, token) => {
      Vue.set(state, "token", token);
    },
    setVertragsObjekte: (state, vertragsObjekte) => {
      if (!state.fetchedVertragsobjekte) {
        Vue.set(state, "vertragsObjekte", vertragsObjekte);
        Vue.set(state, "fetchedVertragsobjekte", true);
      }
    },
    setSelectedObjekt: (state, selectedObjekt) => {
      selectedObjekt.langadresse =
        selectedObjekt.hausnr == null
          ? selectedObjekt.strasse +
          " " +
          selectedObjekt.top +
          ", " +
          selectedObjekt.plz +
          " " +
          selectedObjekt.ort
          : selectedObjekt.strasse +
          " " +
          selectedObjekt.hausnr +
          "/" +
          selectedObjekt.top +
          ", " +
          selectedObjekt.plz +
          " " +
          selectedObjekt.ort;

      selectedObjekt.kurzadresse =
        selectedObjekt.hausnr == null
          ? selectedObjekt.strasse + " " + selectedObjekt.top
          : selectedObjekt.strasse +
          " " +
          selectedObjekt.hausnr +
          "/" +
          selectedObjekt.top;
      Vue.set(state, "selectedObjekt", selectedObjekt);
    },
    setMieter: (state, mieter) => {
      Vue.set(state, "mieter", mieter);
    },
    setLoginEmail: (state, loginEmail) => {
      Vue.set(state, "loginEmail", loginEmail);
    },
    setLoginName: (state, name) => {
      Vue.set(state, "loginName", name);
      Vue.set(state.mieter, "langname", name);
      Vue.set(state.mieter, "kontoname", name);
    },
    setLoginSalutation: (state, salutation) => {
      Vue.set(state, "loginSalutation", salutation);
    },
    setSelectedDokumente: (state, selectedDokumente) => {
      Vue.set(state, "selectedDokumente", selectedDokumente);
    },
    setSchadensfall: (state, schadensfall) => {
      Vue.set(state, "schadensfall", schadensfall);
    },
    setRouterStatus: (state, routerStatus) => {
      Vue.set(state, "routerStatus", routerStatus);
    },
  },
  plugins: [
    createPersistedState({
      // window.sessionStorage    ///ohne 3 folgenden Zeilen...
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
